module.exports = __webpack_public_path__ + "static/media/pisotivityShirt.bc075eae.jpg";